<ng-template #container let-modal>
    <div class="modal-header d-flex align-items-center">
        <h4 class="modal-title" id="modal-basic-title">{{'mail_sender.title' | translate}}</h4>
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="wrapper pb-1">
            <ng-container>
                <div *ngIf="searching === true" class="spinner spinner-border spinner-border-md text-success" role="status">
                    <span class="sr-only"></span>
                </div>
                <tag-input class="tag" [(ngModel)]="items" [validators]="validators" [errorMessages]="errorMessages" [addOnPaste]="true" [onlyFromAutocomplete]="false"
                    placeholder="{{ 'mail_sender.add_email' | translate }}"
                    secondaryPlaceholder="{{ 'mail_sender.enter_email' | translate }}" [pasteSplitPattern]="null" [separatorKeys]="['']" [identifyBy]="'value'"
                    [displayBy]="'display'" required>
                    <tag-input-dropdown [dynamicUpdate]="false" [autocompleteObservable]="requestAutocompleteItems"
                        [appendToBody]="false" [minimumTextLength]="2">
                        <ng-template let-item="item" let-index="index">
                            <div class="row">
                                <span>{{item.display}}</span>
                                <span>{{item.value}}</span>
                            </div>
                        </ng-template>
                    </tag-input-dropdown>
                </tag-input>
            </ng-container>
        </div>
    </div>
    <div class="mt-3 modal-footer">
        <button (click)="send()" [disabled]="items.length === 0 || loading"
            class="btn btn-success">{{ 'mail_sender.send' | translate }}</button>
    </div>
</ng-template>

<ng-template #containerDriver let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{'mail_sender.title' | translate}}</h4>
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="wrapper pb-1">
            <ng-container>
                <tag-input [(ngModel)]="items" [validators]="validators" [errorMessages]="errorMessages"
                    [addOnPaste]="true" placeholder="{{ 'mail_sender.add_email' | translate }}"
                    secondaryPlaceholder="{{ 'mail_sender.enter_email' | translate }}"
                    [pasteSplitPattern]="null" [separatorKeys]="['']" required>
                </tag-input>
            </ng-container>
        </div>
        <br>
        <p class="p-small"><span style="color: red">* </span>{{'mail_sender.instruccion' | translate}}</p>
    </div>
    <div class="mt-3 modal-footer">
        <button (click)="send()" [disabled]="items.length === 0 || loading"
            class="btn btn-success">{{ 'mail_sender.send' | translate }}</button>
    </div>
</ng-template>